var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-6 flex flex-col gap-4"},[_c('ChatGPTEditorFormRowFull',{attrs:{"item":_vm.INSTRUCTIONS,"is-item-error":false,"row-count":20,"token-count":_vm.promptTokenCount,"is-disabled":true,"action":_vm.displayAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }